import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { HelplistService } from 'app/helplist.service';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SearchNewSurgeryComponent } from './search-new-surgery/search-new-surgery.component';

@Component({
  selector: 'app-add-new-surgery',
  templateUrl: './add-new-surgery.component.html',
  styleUrls: ['./add-new-surgery.component.scss']
})
export class AddNewSurgeryComponent implements OnInit {
  SurdepartmentCtrl: FormControl;
  filteredSDeptArray: Observable<any[]>;
  SurcategoryCtrl: FormControl;
  filteredSCategory: Observable<any[]>;
  OpTypeCtrl: FormControl;
  filteredOpTypeArray: Observable<any[]>;
  SurgerydepartmentName: any = '';
  disableupdatebutton: boolean = true;
  showspinner: boolean = false;
  getOPTypeArray: any = [];
  pkdepartmentid: number = 0;
  pkcategoryid: number = 0;
  SurgerycatName: string = "";
  opTypeName: string = '';
  opTypeId: number = 0;
  isActive: boolean = false;
  surgeryName: string = '';
  surgeryCode: string = "";
  SortName: string = "";
  pksurgeryid: number = 0;
  constructor(public dialog: MatDialog, public dashboardService: DashboardService,
    public emrservice: EMRService,
    public authService: AuthService, public ipdService: IPDService,
    public helplistservice: HelplistService, public dialogRef: MatDialogRef<AddNewSurgeryComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.GetotTypeData();
    this.SurdepartmentControll();
    this.SurCategoryControll(this.helplistservice.surgery_departments[0]?.pkSurgeryDeptId);
    this.OpTypeControll();
  }
  closedialog() {
    this.dialogRef.close(0);
  }
  Cancelpopup(type) {
    if (type == 1) {
      document.getElementById("surgerycatModal").style.display = "Block";
    } else {
      document.getElementById("surgerycatModal").style.display = "None";
    }
  }
  clearData() {
    this.disableupdatebutton = true;
    this.SurgerycatName = "";
    this.surgeryCode = "";
    this.SortName = "";
    this.surgeryName = "";
    this.pkdepartmentid = 0;
    this.pkcategoryid = 0;
    this.opTypeId = 0;
    this.isActive = false;
    this.SurgerydepartmentName = "";
    this.opTypeName = "";
    this.pksurgeryid = 0
  }

  //autocomplet
  SurdepartmentControll() {

    this.SurdepartmentCtrl = new FormControl();
    this.filteredSDeptArray = this.SurdepartmentCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctorfunction(cat) : this.helplistservice.surgery_departments.slice())
      );

  }

  filterdoctorfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.helplistservice.surgery_departments.filter(country =>
      country.surgeryDeptName?.toLowerCase().indexOf(filterValue) === 0);

  }

  getDepartmentobj(e: any) {
    var val = e.option.value;
    this.SurgerydepartmentName = val.surgeryDeptName;
    this.pkdepartmentid = val.pkSurgeryDeptId;
    if(val.pkSurgeryDeptId > 0){
      this.SurCategoryControll(val.pkSurgeryDeptId);
    }

  }

  CheckinputDept(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.SurdepartmentControll();
      this.pkdepartmentid = 0;
      this.SurgerydepartmentName = "";
    }
  }

  //autocomplet
  SurCategoryControll(pkSurgeryDeptId) {
    this.SurcategoryCtrl = new FormControl();
    this.filteredSCategory = this.SurcategoryCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterCatfunction(cat) : this.helplistservice.categories.filter(obj=> obj.fkSurgeryDeptId == pkSurgeryDeptId).slice())
      );
      this.SurgerycatName = '';
  }

  filterCatfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.helplistservice.categories.filter(country =>
      country.surgeryCatName?.toLowerCase().indexOf(filterValue) === 0);

  }

  getCategoryobj(e: any) {
    var val = e.option.value;
    this.SurgerycatName = val.surgeryCatName;
    this.pkcategoryid = val.pkSurgeryCatId;
    // this.departmentid = val.deptId;

  }

  // CheckinputCategory(event: any) {

  //   var checkdata = event.target.value;
  //   if (checkdata == "") {
  //     this.SurCategoryControll(this.pkdepartmentid);
  //     this.pkcategoryid = 0;
  //     this.SurgerycatName = "";
  //   }
  // }

  //Get Opertation Type
  GetotTypeData() {
    this.getOPTypeArray = [];
    try {
      this.ipdService.GetOPType().subscribe(item => {
        this.getOPTypeArray = item;
        this.OpTypeControll();
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    }
    catch (e) {

    }
  }
  //Autocomplete Op type 

  OpTypeControll() {

    this.OpTypeCtrl = new FormControl();
    this.filteredOpTypeArray = this.OpTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat) : this.getOPTypeArray.slice())
      );

  }

  filterOpfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.getOPTypeArray.filter(country =>
      country.operationTypeName?.toLowerCase().indexOf(filterValue) === 0);
  }

  getOpTypeobj(e: any) {
    var val = e.option.value;
    console.log(val)
    this.opTypeName = val.operationTypeName;
    this.opTypeId = val.pK_OperationTypeId;
  }

  CheckinputOpType(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.OpTypeControll();
      this.opTypeId = 0;

    }
  }
  addNewSurgery(type) {
   
    if (this.surgeryName != "" &&
      this.pkcategoryid > 0 && this.SurgerycatName != "" && this.SurgerydepartmentName != "") {
      if (type == 1) {
        this.showspinner =true;
        let payload = {
          "IsActive": this.isActive,
          "PkSurgeryId": this.pksurgeryid == 0?0: this.pksurgeryid,
          "FkSurgeryCatId": this.pkcategoryid,
          "FK_OperationtypeId": this.opTypeId ? this.opTypeId : 0,
          "SurgeryCode": this.surgeryCode ? this.surgeryCode : null,
          "SurgeryName": this.surgeryName,
          "ShortName": this.SortName ? this.SortName : null,
          "InternationalName": null,
          "ArabicSurgeryName": null,
          "ArabicSurgeryNameWeb": null,
          "IsEdit":this.pksurgeryid>0? true:false
        }
        this.emrservice.InsertSurgeryMaster(payload).subscribe(data => {
          if (data['statusCode'] == 1) {
            if(this.pksurgeryid>0){
              this.dashboardService.openSnackBar("Record Updated Successfully", "OK"); 
            }else{
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
            }           
            this.clearData();
            this.helplistservice.get_surgerylist(0,0);
            this.dialogRef.close(1);
            this.showspinner =false;
            
          }

        }, err => {
          this.showspinner =false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
      } else if (type == 2) {
        this.showspinner =true;
        if (this.pksurgeryid > 0) {
          let payload1 = {
            "IsActive": this.isActive,
            "PkSurgeryId": this.pksurgeryid,
            "FkSurgeryCatId": this.pkcategoryid,
            "FK_OperationtypeId": this.opTypeId ? this.opTypeId : 0,
            "SurgeryCode": this.surgeryCode ? this.surgeryCode : null,
            "SurgeryName": this.surgeryName,
            "ShortName": this.SortName ? this.SortName : null,
            "InternationalName": null,
            "ArabicSurgeryName": null,
            "ArabicSurgeryNameWeb": null,
            "IsEdit": true
          }
          this.emrservice.InsertSurgeryMaster(payload1).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.dashboardService.openSnackBar("Record Updated Successfully", "OK");             
              this.helplistservice.get_surgerylist(0,0);              
              this.clearData();
              this.dialogRef.close(1);
              
            }
            // this.showspinner =false;
          }, err => {
            this.showspinner =false;
            // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        } else {
          this.showspinner =false;
          this.dashboardService.openSnackBar("Please select Surgery From list", "OK");
        }


      } else if (type == 3) {
        if (this.pksurgeryid > 0) {
          this.showspinner =true;
          let payload2 = {
            "PkSurgeryId": this.pksurgeryid, "IsActive": false, "IsHidden": true, "IsEdit": true
          }
          this.emrservice.InsertSurgeryMaster(payload2).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
              document.getElementById("surgerycatModal").style.display = "None";              
              this.helplistservice.get_surgerylist(0,0);
              this.clearData();
              this.dialogRef.close(1);
            }
            this.showspinner =false;
          }, err => {
            this.showspinner =false;
            // this.dashboardService.openSnackBar("API Failed :" + err.status + " Internal Server Error", "OK");
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        } else {
          this.dashboardService.openSnackBar("Please select Surgery From list", "OK");
        }

      }
    } else {
      this.dashboardService.openSnackBar("Required fields are mandatory", "OK");
    }
  }
  openSearchSurgery(): void {
    this.clearData();
    const dialogRef = this.dialog.open(SearchNewSurgeryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '90vw',
      width: '90%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
   
      if (result != 0) {
        console.log(result)
        this.disableupdatebutton = true;
        this.SurgerycatName = result.surgeryCatName;
        this.surgeryCode = result.surgeryCode;
        this.SortName = result.shortName;
        this.surgeryName = result.surgeryName;
        this.pkdepartmentid = result.fK_SurgeryDeptId;
        this.pkcategoryid = result.fkSurgeryCatId;
        this.opTypeId = result.fK_OperationtypeId;
        this.isActive = result.isActive ? result.isActive : false;
        this.SurgerydepartmentName = result.surgeryDeptName;
        this.opTypeName = result.operationTypeName;
        this.pksurgeryid = result.pkSurgeryId;
      }
    });
  }
}
